/*
 * H2AuditQueries.tsx
 *
 * Created by Dr. Maximillian Dornseif 2023-11-06 in huWaWi3 33.4.0
 * Copyright (c) 2023 HUDORA GmbH
 */

import gql from 'graphql-tag';

export const AUFTRAGAUDIT_QUERY = gql`
  query AuftragAudit($nr: ID!) {
    entity: hwAuftrag(designator: $nr) {
      id
      auditLog {
        id
        designator
        level
        object_name
        message
        src_file
        src_func
        src_line
        gae_version
        gae_service
        created_by2
        created_at
        updated_at
      }
    }
  }
`;
